const AVATARS: Array<[string, string]> = [
  ['#dcebe6', '#0c5c4e'],
  ['#e4e2f3', '#4a3fa3'],
  ['#f3e8dc', '#8a5410'],
  ['#dce7f3', '#2c5a94'],
  ['#f3dcdf', '#94303c'],
  ['#e2f0da', '#3e6b1f'],
];

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 3)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

export function avatarColors(name: string): [string, string] {
  const index = ((name.charCodeAt(0) || 0) + name.length) % AVATARS.length;
  return AVATARS[index];
}

export function relativeTime(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '—';
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '—';
  const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 60) return `${days}d ago`;
  return shortDate(iso);
}

export function shortDate(iso: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toISOString().slice(0, 10);
}
